<div class="row">
  <main class="main col-12">
    <section class="main__section">
      <cir-pub-highlights [showArchive]="true"></cir-pub-highlights>
    </section>
  </main>
</div>

